/**
 * Left-aligned bubble for system / AI content (captured notes, ask
 * answers, digests, system events). Uses the secondary surface with a
 * hairline ring so it reads as a card without a hard border.
 */
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Subtle headline shown above the bubble. */
  title?: ReactNode;
  /** Subscript shown under the bubble (timestamp, links). */
  meta?: ReactNode;
}

export function AssistantBubble({
  children,
  title,
  meta,
}: Props): React.ReactElement {
  return (
    <div className="flex flex-col items-start gap-0.5 px-3 py-0.5 max-w-[88%]">
      {title ? (
        <div
          className="text-[10px] uppercase tracking-wider font-medium pl-1"
          style={{ color: "var(--color-hint)" }}
        >
          {title}
        </div>
      ) : null}
      <div
        className="rounded-[18px] rounded-bl-[6px] px-3 py-1.5 text-[14px] leading-[19px] break-words"
        style={{
          background: "var(--color-secondary-bg)",
          color: "var(--color-text)",
          boxShadow: "var(--shadow-1)",
        }}
      >
        {children}
      </div>
      {meta ? (
        <div
          className="text-[10px] pl-1"
          style={{ color: "var(--color-hint)" }}
        >
          {meta}
        </div>
      ) : null}
    </div>
  );
}
